import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Estilos/Toggle.css';
import Switch from '@mui/material/Switch';
import Cookies from 'js-cookie';
import { StoreContexto } from '../Contexto/Provider';
// import { Container } from './styles';

const Esqueceu = (props) => {
  const { setKeepOn } = useContext(StoreContexto);
  const [updatedFeature, setUpdatedFeature] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Switch
          color="success"
          value={localStorage.getItem('KeepOn') ? true : false}
          onChange={(v) => {
            if (v.target.checked) {
              Cookies.remove('KeepOn');
              localStorage.setItem('KeepOn', 'local');
              setKeepOn('local');
            } else {
              localStorage.clear();
              Cookies.set('KeepOn', 'session');
              setKeepOn('session');
            }
          }}
        />

        <p style={{ fontSize: 14, color: '#545e6b', textAlign: 'right', fontFamily: 'montserrat' }}>
          Deixar Conectado
        </p>
      </div>

      <Link to="/ResetPassword">
        <u style={{ fontSize: 14, color: '#545e6b', textAlign: 'right', fontFamily: 'montserrat' }}>
          Esqueceu a senha?
        </u>
      </Link>
    </div>
  );
};

export default Esqueceu;
